import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_how_does_facility_ensure_temperature_maintained_provide'

export const dataPointDefinition = {
  retracedId: 'no_how_does_facility_ensure_temperature_maintained_provide',
  name: 'If no, how does the facility ensure the temperature is maintained to provide a healthy and safe working environment?',
  description:
    "Please explain your awareness around heat and cold stress and if and how you ensure workers are working under temperatures that are safe for them. For example, regular breaks or changes in work schedules can be introduced to regulate the workers' body temperature. ",
  meta: {
    slcpMeta: {
      key: 'hs-gen-22',
      number: 'HS-GEN-8',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-22', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31260,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
